import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilsModule } from '@tres-erres/ngx-utils';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

/* Material Modules */
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

/** Dialogs */
import {
	LoginDialog,
	InformeWDialog,
	InformeUploader,
	espereDialog
} from '@app/shared/dialogs';

/** Modules */


/** Directives */
import { FocusNextDirective } from './focus-next.directive';

import { HttpService } from '@app/core';

import { ComponentesModule, HttpService as ComponentesHttpService } from '@componentes/.';
import { CopyClipboardDirective } from './copy-clipboard.directive';


import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		/* Custom Modules */
		ComponentesModule,

		/* Material Modules */
		MatFormFieldModule,
		MatButtonModule,
		MatInputModule,
		MatCardModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatDialogModule,
		MatToolbarModule,
		MatIconModule,
		MatCheckboxModule,
		MatTabsModule,
		MatSelectModule,
		MatTableModule,
		MatRadioModule,
		MatSidenavModule,
		MatListModule,
		MatMenuModule,

		UtilsModule,
		CKEditorModule
	],
	declarations: [
		/* Directives */
		FocusNextDirective,
		BreadcrumbsComponent,
		/** Dialogs */
		LoginDialog,
		InformeWDialog,
		InformeUploader,
		espereDialog,
		CopyClipboardDirective
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		/* Custom Modules */
		ComponentesModule,
		UtilsModule,
		CKEditorModule,

		/* Material Modules */
		MatFormFieldModule,
		MatButtonModule,
		MatInputModule,
		MatCardModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatDialogModule,
		MatToolbarModule,
		MatTabsModule,
		MatIconModule,
		MatCheckboxModule,
		MatSelectModule,
		MatTableModule,
		MatRadioModule,
		MatSidenavModule,
		MatListModule,
		MatMenuModule,

		/** Directives */
		FocusNextDirective,
		CopyClipboardDirective,

		/** Dialogs */
		LoginDialog,
		InformeWDialog,
		InformeUploader,
		espereDialog,

		/** BreadCrumbs */
		BreadcrumbsComponent,


	],
	entryComponents: [
		/** Dialogs */
		LoginDialog,
		InformeWDialog,
		InformeUploader,
		espereDialog
	],
	providers: [
		{ provide: ComponentesHttpService, useClass: HttpService }
	]
})
export class SharedModule { }
